module.exports = __webpack_public_path__ + "static/banana-63a682faa7829c427cb010074587a2a8.svg";